<template>
    <el-form
        ref="checkForm"
        :model="profile"
        :rules="rules"
        label-width="100px"
        class="formBox"
        label-suffix=":"
    >
        <div v-for="(item, index) in userfile" :key="index">
            <el-form-item
                v-if="item.IsShow"
                :label="item.DisplayName"
                :prop="item.IsEdit ? item.Code : null"
            >
                <div v-if="!item.IsEdit">
                    <span>{{ profile[item.Code] }}</span>
                </div>
                <div v-else-if="item.Code === 'IDNumber'">
                    <div v-if="item.IsEdit">
                        <el-input :placeholder="item.PlaceHolder" v-model="profile[item.Code]"></el-input>
                    </div>
                    <div v-else>
                        <span>{{ profile[item.Code] }}</span>
                    </div>
                </div>
                <div v-else-if="item.Code === 'Birthday'">
                    <div v-if="item.IsEdit">
                        <el-date-picker v-model="profile[item.Code]" type="date"></el-date-picker>
                    </div>
                    <div v-else>
                        <span>{{ profile[item.Code] }}</span>
                    </div>
                </div>
                <div v-else-if="item.Code === 'Email'">
                    <div v-if="item.IsEdit">
                        <el-input :placeholder="item.PlaceHolder" v-model="profile[item.Code]"></el-input>
                    </div>
                    <div v-else>
                        <span>{{ profile[item.Code] }}</span>
                    </div>
                </div>
                <div v-else-if="item.Code === 'IsShowMobile'">
                    <el-switch style="display:inline-block;" v-model="profile[item.Code]"></el-switch>
                    <span v-if="profile[item.Code]" style="margin-left:20px;">是</span>
                    <span v-else style="margin-left:20px;">否</span>
                    <div>{{ item.Description }}</div>
                </div>
                <div v-else>
                    <el-input :placeholder="item.PlaceHolder" v-model="profile[item.Code]"></el-input>
                </div>
            </el-form-item>
        </div>
    </el-form>
</template>
<script>
import enterpriseService from '../../services/enterprise.service';
import commonMethod from '@/components/commethod/commethod';
import UserService from '@/services/user.service.js';
import validator from '@/utils/validator.js';
import { IsNull } from '@/utils/utils.js';
export default {
    data() {
        return {
            profile: {},
            userfile: {},
            rules: {},
            profileArr: [],
        };
    },
    created() {
        this.getUserFile();
        this.getPersonalFile();
    },
    methods: {
        confirmAction: function() {
            return this.$refs.checkForm.validate().then(() => {
                delete this.profile.$type;
                return UserService.updateUserInfo(this.profile).then(res => {
                    if (!res.Success) {
                        this.$message(res.Message);
                        return;
                    } else {
                        this.$message('更新个人资料成功！');
                        this.$emit('modalClose');
                    }
                });
            });
        },
        async getPersonalFile() {
            //const authEffectiveTime = await enterpriseService.getAuthCodeTime();
            enterpriseService.getPrivateKey().then(privateKey => {
                const keyCode = commonMethod.encodeUserKey(privateKey);
                UserService.getPersonalFile(keyCode).then(res => {
                    this.profile = res.Result;
                });
            });
        },
        checkEmail(rule, value, callback) {
            if (IsNull(value)) {
                callback();
            } else {
                if (!validator.validator(3, value)) {
                    callback(new Error('请输入正确的邮箱'));
                } else {
                    callback();
                }
            }
        },
        checkIDNumber(rule, value, callback) {
            if (IsNull(value)) {
                callback();
            } else {
                if (!validator.validator(2, value)) {
                    callback(new Error('请输入正确的身份证号'));
                } else {
                    callback();
                }
            }
        },
        checkMobile(rule, value, callback) {
            if (IsNull(value)) {
                callback();
            } else {
                if (!validator.validator(0, value)) {
                    callback(new Error('请输入正确的手机号'));
                } else {
                    callback();
                }
            }
        },
        getUserFile() {
            UserService.getUserFile().then(res => {
                this.userfile = res.Result;
                const rules = {};
                this.userfile.forEach(item => {
                    const itemRules = [];
                    if (item.IsRequired) {
                        itemRules.push({
                            required: true,
                            message: item.PlaceHolder,
                            trigger: 'blur',
                        });
                    }
                    if (item.Code === 'Email') {
                        itemRules.push({
                            validator: this.checkEmail,
                            trigger: 'blur',
                        });
                    } else if (item.Code === 'IDNumber') {
                        itemRules.push({
                            validator: this.checkIDNumber,
                            trigger: 'blur',
                        });
                    } else if (item.Code === 'Mobile') {
                        itemRules.push({
                            validator: this.checkMobile,
                            trigger: 'blur',
                        });
                    }
                    rules[item.Code] = itemRules;
                });
                this.rules = rules;
            });
        },
        close() {
            this.$emit('modalClose');
        },
    },
};
</script>
<style scoped>
.formBox {
    /* padding:0 100px; */
    padding: 20px 60px;
    border-top: 1px solid #e7e7e7;
}

.hideMobile,
.showMobile {
    display: inline-block;
    text-align: center;
    width: 60px;
    height: 30px;
    background: #fff;
    border: 1px solid #e7e7e7;
    cursor: pointer;
}

.hideMobile:hover {
    color: #1890ff;
}

.hideMobile:visited {
    border: 1px solid #1890ff;
}

.showMobile:hover {
    color: #1890ff;
    border: 1px solid #1890ff;
}
</style>